import {API_KEY} from "./my_key.js";
import {book_output,book_01} from "./book.js";



export async  function bible_init(){
  var jsonArray = [];

  const versionList = document.querySelector(`#bible-version-list`);
      let versionHTML = ``;
   await    getBibleVersions().then((bibleVersionList) => {
        const sortedVersions = sortVersionsByLanguage(bibleVersionList);

        var option = document.createElement("option");
         option.text ="Choose Bible Type";
              // document.getElementById("bible_type").appendChild(option);
        for (let languageGroup in sortedVersions) {
          const language = languageGroup;
          const versions = sortedVersions[languageGroup];
          for (let version of versions) {
   
            if(version.abbreviation == "engKJV"){
var jsonObject = {
  "id": version.id,
  "value": version.abbreviation,
  "text": version.name + "-" +version.description
};

jsonArray.push(jsonObject);


           // console.log(version.abbreviation);
           // document.getElementById("bible_type").appendChild(option);
          }

         /*   var option = document.createElement("option");
            option.id = version.id;
            option.value = version.abbreviation;
            option.text = version.abbreviation + " " + version.name + "-" +version.description;

            console.log(version.abbreviation);
            document.getElementById("bible_type").add(option);
}
          
*/
          }
        }
      });


      /**
       * Gets Bible versions from API.Bible
       * @returns {Promise} containing list of Bible versions
       */
    async function getBibleVersions() {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = false;


xhr.onload = function() {
  
    if (this.responseText) {
              const {data} = JSON.parse(this.responseText);
              const versions = data.map( (data) => {
                return {
                  name: data.name,
                  id: data.id,
                  abbreviation: data.abbreviation,
                  description: data.description,
                  language: data.language.name
                };
              });

              resolve(versions);
            }else{
             console.log(this.responseText);
                  console.log("apa");
             // getBibleVersions();
            }
}
       /*   xhr.addEventListener(`readystatechange`, function() {
            //console.log(this.responseText);
            if (this.readyState === this.DONE) {
              if (this.responseText === '') {
                     console.log(this.responseText);
                  console.log("apa");
              const {data} = JSON.parse(this.responseText);
              const versions = data.map( (data) => {
                return {
                  name: data.name,
                  id: data.id,
                  abbreviation: data.abbreviation,
                  description: data.description,
                  language: data.language.name
                };
              });

              resolve(versions);
            }}else{
             console.log(this.responseText);
                  console.log("apa");
             // getBibleVersions();
            }
          });
*/
          xhr.open(`GET`, `https://api.scripture.api.bible/v1/bibles`);
          xhr.setRequestHeader(`api-key`, API_KEY);

          xhr.onerror = () => reject(xhr.statusText);

          xhr.send();
          xhr.addEventListener("error",transferFailed);
        });
      }

function transferFailed(evt) {
        console.log("An error occurred while transferring the file.");
        bible_init();
        // Do something
    }
      /**
       * Sorts Bible versions by language and alphabetically by abbreviation
       * @params {Object} bibleVersionList list of Bible versions
       * @returns {Object} sorted list of Bibles
       */
      function sortVersionsByLanguage(bibleVersionList) {
        let sortedVersions = {};

        for (const version of bibleVersionList) {
          if (!sortedVersions[version.language]) {
            sortedVersions[version.language] = [];
          }
          sortedVersions[version.language].push(version);
        }
        for (const version in sortedVersions) {
          sortedVersions[version].sort( (a, b) => {
            const nameA = a.abbreviation.toUpperCase();
            const nameB = b.abbreviation.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          } );
        }
        return sortedVersions;
      }

return jsonArray;

    }